import { ResponseError } from '../../api-internal';
import { ResponseError as PublicResponseError } from '../../api';

interface ErrorDetails {
  description: string;
  reason: string;
  position?: number;
}

export interface ErrorResponse {
  code: number;
  message: string;
  details?: ErrorDetails;
}

const defaultErrorMsg = 'Oops, something went wrong';

export const parseErrorMessage = async (e: unknown): Promise<string> => {
  if (e instanceof ResponseError) {
    return parseErrorResponse(e.response);
  } else if (e instanceof PublicResponseError) {
    return parseErrorResponse(e.response);
  } else if (e instanceof Response) {
    return await parseErrorResponse(e);
  } else if (e instanceof Error) {
    return e.message;
  }
  return defaultErrorMsg;
};

const parseErrorResponse = async (e: Response): Promise<string> => {
  try {
    const response = (await e.json()) as ErrorResponse;
    if (response.details) {
      return response.details.description;
    } else {
      return response.message;
    }
  } catch {
    return defaultErrorMsg;
  }
};
